// API Request
// ------------------------------
export type ListUserList = {
    accountId: number;
};

export const initListUserListt: ListUserList = {
    accountId: 0,
};

export type CreateUserList = {
    name: string;
    description: string;
    usePreference: string[];
    file: string;
    fileName: string;
    accountId: number;
    createdBy: number;
};

export const initCreateUserListt: CreateUserList = {
    name: "",
    description: "",
    usePreference: [],
    file: "",
    fileName: "",
    accountId: 0,
    createdBy: 0,
};

export type UpdateUserList = {
    id: number;
    description: string;
    usePreference: string[];
    file: string;
    fileName: string;
    updatedBy: number;
    expectedVersion: number;
};

export type DeleteUserList = {
    id: number;
    updatedBy: number;
    expectedVersion: number;
};

// API Response
// ------------------------------
export type ResListUserLists = {
    id: number;
    name: string;
    status: string;
    uu: number;
    usePreference: string;
    updatedAt: string;
    updatedBy: string;
};
 
export type ResGetUserList = {
    name: string;
    description: string;
    usePreference: string[];
    uu: number;
    fileName: string;
    createdAt: string;
    createdBy: number;
    updatedAt: string;
    updatedBy: number;
    uploadedAt: string;
    version: number;
};

export const initResGetUserList: ResGetUserList = {
    name: "",
    description: "",
    usePreference: [],
    uu: 0,
    fileName: "",
    createdAt: "",
    createdBy: 0,
    updatedAt: "",
    updatedBy: 0,
    uploadedAt: "",
    version: 0,
};
